import VueGtag, { bootstrap } from "vue-gtag";

export const installAnalytics = (app, router, config) => {
  app.use(VueGtag, { config, bootstrap: false }, router);

  // External auth redirects abort the initial navigation and reject isReady().
  // Start the plugin's readiness subscription only after navigation succeeds.
  const stop = router.afterEach((_to, _from, failure) => {
    if (failure) return;
    stop();
    bootstrap();
  });
};
